import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IState } from '../../../store/reducers';
import { loadSearchUser, resetSearch } from '../../../store/actions/noteflowActions';
import { ApiStatus } from '../../../models';
import { SelectAsync } from './SelectAsync';
import { SEARCH_TYPE } from './contants';

type Callback = (value: any) => void;

interface ISelectUserContainerProps {
  onChange: Callback;
  reset: boolean;
}

const parseResult = (result: null | any) => {
  if (result) {
    return result
      .map((user: any) => ({...user, name: `${user.first_name} ${user.last_name}`}));
  }
  return null;
}

export const SelectUserContainer = ({
  onChange,
  reset,
}: ISelectUserContainerProps) => {
  const [ selected, setSelected ] = useState<any>(null);
  const loadingStatus = useSelector((state: IState) => state.noteflow.searchLoadingStatus);
  const results = useSelector((state: IState) => state.noteflow.searchResults.users);
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetSearch(SEARCH_TYPE.USER));
    };
  }, [ ]);

  const onSearch = (text: string) => {
    if (text !== '') {
      if (text.trim().length > 1) {
        // search at least 2 characters
        dispatch(loadSearchUser(text));
      }
    }
  }

  const onSelect = (item: any) => {
    setSelected(item);
    onChange(item);
  };

  useEffect(() => {
    if (reset) {
      setSelected(null);
    }
  }, [ reset ]);

  return (
    <SelectAsync
      selected={selected}
      onSearch={onSearch}
      onSelect={onSelect}
      results={parseResult(results)}
      loading={loadingStatus === ApiStatus.LOADING}
      label="Running User"
    />
  )
};

export default SelectUserContainer;
